import { isly } from "isly";
import { Date } from "../Date";
import { DayOfWeek } from "../DayOfWeek";
import { system } from "../system";
import { Number } from "./Number";
export var Parts;
(function (Parts) {
    var _a;
    _a = isly
        .object({ year: isly.number(), week: Number.Numeric.type }, "isoly.Week.Parts")
        .bind(), Parts.type = _a.type, Parts.is = _a.is, Parts.flawed = _a.flawed;
    function from(date) {
        const parsed = new system.Date(date);
        parsed.setUTCDate(parsed.getUTCDate() + 4 - (parsed.getUTCDay() || 7));
        const start = new system.Date(system.Date.UTC(parsed.getUTCFullYear(), 0, 1));
        const week = Math.ceil(((parsed.getTime() - start.getTime()) / 86400000 + 1) / 7);
        return { year: parsed.getUTCFullYear(), week };
    }
    Parts.from = from;
    function now() {
        return from(Date.now());
    }
    Parts.now = now;
    function next(week, weeks = 1) {
        return from(Date.next(first(week), weeks * 7));
    }
    Parts.next = next;
    function previous(week, weeks = 1) {
        return next(week, -weeks);
    }
    Parts.previous = previous;
    function first(week) {
        const year = week.year.toString().padStart(4, "0");
        const result = new system.Date(`${year}-01-01`);
        const jan4th = new system.Date(`${year}-01-04`);
        const jan4thDay = (jan4th.getUTCDay() + 6) % 7;
        const ordinalDate = 1 + (week.week - 1) * 7 - jan4thDay + 3;
        result.setUTCDate(ordinalDate);
        return Date.create(result);
    }
    Parts.first = first;
    function last(week) {
        return getDate(week, 7);
    }
    Parts.last = last;
    function getDate(week, day) {
        return Date.next(first(week), (DayOfWeek.Numeric.is(day) ? day : DayOfWeek.toNumeric(day)) - 1);
    }
    Parts.getDate = getDate;
    function getDays(week) {
        const monday = first(week);
        return [...Array(7).keys()].map(day => Date.next(monday, day));
    }
    Parts.getDays = getDays;
    function lastWeek(year) {
        return previous({ year: year + 1, week: 1 }).week;
    }
    Parts.lastWeek = lastWeek;
})(Parts || (Parts = {}));
//# sourceMappingURL=Parts.js.map